// Compendia brand palette for chart slices. Core brand colors first, then
// their tints so charts with many options still get distinct, on-brand colors.
const compendiaColors = [
    "var(--color-chart-1)", // chameleon green
    "var(--color-chart-2)", // chameleon pink
    "var(--color-chart-3)", // chameleon yellow
    "var(--color-chart-4)", // surface teal-dark
    "var(--color-chart-5)", // greige dark
    "var(--color-chameleon-green-60)",
    "var(--color-chameleon-pink-60)",
    "var(--color-chameleon-yellow-60)",
    "var(--color-surface-teal-light)",
    "var(--color-compendia-greige)",
];

export default function getChartColor(index: number): string {
    const base = compendiaColors[index % compendiaColors.length];
    const cycle = Math.floor(index / compendiaColors.length);

    // Within the first pass, use the brand colors as-is.
    if (cycle === 0) return base;

    // Once we run out, keep going on-brand by deriving distinct shades of the
    // same base colors — alternating lighter / darker on each wrap so repeated
    // hues never look identical, no matter how many options the chart has.
    const lighten = cycle % 2 === 1;
    const amount = Math.min(15 + Math.ceil(cycle / 2) * 20, 70);
    return `color-mix(in oklch, ${base}, ${lighten ? "white" : "black"} ${amount}%)`;
}
